/*
This function updates the styling of a standard ad iframe depending
on the size that was served -- we declare a range of sizes we accept
and Google decides which of the creatives to inject. This function
adds some padding and max-width according to the size of the creative served.
*/
export const iabStandardFlexibleAdSizesCallback = (event) => {
  const iframe = document.getElementById(event.source.name);
  const parentElement = iframe.parentElement.parentElement;
  const paddingBottom = `min(${event.data.aspectRatio}, ${event.data.maxHeight})`;
  parentElement.style.paddingBottom = paddingBottom;
  iframe.style.maxWidth = event.data.maxWidth;
}
